import { usePermissions } from 'contexts';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { openModal } from 'store/modals/modals.slice';
import { deleteUserThunk, getUsersThunk } from 'store/users/users.thunks';

import { MODAL_USER } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import { PaginationPanel } from '../../panels/pagination-panel/pagination-panel';
import { UserPanel } from '../../panels/user-panel/user-panel';
import { Container } from '../../template/container/container';
import { ConfirmationModal } from '../../template/modals/confirmation-modal';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';
import { PageHeader } from '../../template/page-header/page-header';
import { Spinner } from '../../template/spinner/spinner';

const UsersPage = () => {
  const role = localStorage.getItem('role');
  const userId = localStorage.getItem('userId');
  const permissions = usePermissions();
  const [page, setPage] = useState(0);

  const users = useAppSelector((state) => state.users);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUsersThunk(page));
  }, [dispatch, page]);

  const changePage = (page: number): void => {
    setPage(page);
    dispatch(getUsersThunk(page));
  };

  const handleClick = () => {
    dispatch(
      openModal({
        name: MODAL_USER,
        data: { page },
      }),
    );
  };

  const renderInviteNewUserButton = (): JSX.Element | undefined => {
    if (permissions.permissions.inviteNewUsers === true) {
      return (
        <CreateButton
          text={vocabulary.buttons.inviteUser}
          onClick={handleClick}
        />
      );
    }
  };

  const showRemoveConfirmationModal = (
    id: number,
    event: React.MouseEvent<HTMLElement>,
  ): void => {
    event.stopPropagation();

    confirmAlert({
      customUI: ({ onClose }): JSX.Element => {
        return (
          <ConfirmationModal
            onClose={onClose}
            onOk={() => dispatch(deleteUserThunk({ id, page }))}
          />
        );
      },
    });
  };

  const renderUsersList = () => {
    const isAdmin = role === 'admin';
    const { totalPages } = users;

    if (!users.isGetUsersThunkPending) {
      if (users.list.length > 0) {
        return (
          <div className={'entities-list'}>
            {users.list.map((item, index) => (
              <div className={'users-item'} key={index}>
                <UserPanel
                  name={item.username}
                  email={item.email}
                  status={item.registrationStatus}
                  role={item.roles[0]}
                  id={item.id}
                  isDeletable={
                    isAdmin &&
                    item.username !== 'admin' &&
                    Number(userId) !== item.id
                  }
                  onDelete={(event) =>
                    showRemoveConfirmationModal(item.id, event)
                  }
                />
              </div>
            ))}
            <PaginationPanel
              changePage={changePage}
              totalPages={totalPages}
              page={page}
            />
            {renderInviteNewUserButton()}
          </div>
        );
      } else {
        return (
          <>
            <NotFoundMessage message={`Nicht gefunden`} />
            {renderInviteNewUserButton()}
          </>
        );
      }
    } else {
      return <Spinner />;
    }
  };

  return (
    <div className={'page-content'}>
      <PageHeader
        title={vocabulary.labels.users}
        btnText=""
        downloadReport={null}
      />
      <Container>{renderUsersList()}</Container>
    </div>
  );
};

export default UsersPage;
